<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col lg="5" cols="6">
                        <VDateInput
                            label="От"
                            v-model="from"
                            :max="maxFromDate"
                        />
                    </v-col>
                    <v-col lg="5" cols="6">
                        <VDateInput
                            label="До (включително)"
                            v-model="to"
                            :min="minToDate"
                        />
                    </v-col>
                    <v-col lg="2"  cols="2" align-self="center" class="text-center">
                        <v-btn color="success" @click="getReport" :loading="loading">Справка</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card class="mt-8" v-if="reportRequested">
            <v-data-table
                :headers="byCityHeaders"
                :items="byCityItems"
                disable-pagination
                hide-default-footer
                :loading="loading"
            >
                <template v-slot:top>
                    <v-container>
                        <div class="title">Справка по градове</div>
                    </v-container>
                </template>

                <template v-slot:body.append>
                    <tr style="font-weight:bold" v-if="byCitySummray">
                        <td>Общо</td>
                        <td>{{ byCitySummray.clientsCount }}</td>
                        <td>{{ byCitySummray.locationsCount }}</td>
                        <td>{{ byCitySummray.mats }}</td>
                        <td>{{ byCitySummray.services }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

        <v-card class="mt-8" v-if="reportRequested">
            <v-data-table
                :headers="byMatHeaders"
                :items="byMatTypeItems"
                disable-pagination
                hide-default-footer
                :loading="loading"
            >
                <template v-slot:top>
                    <v-container>
                        <div class="title">Справка по видове изтривалки</div>
                    </v-container>
                </template>

                <template v-slot:item.matVariant="{ item }">
                    {{ rendMatType(item.matTypeId) }}
                </template>

                <template v-slot:item.cities="{ item }">
                    <v-chip v-for="(city, k) in item.cities" :key="k" x-small>
                        {{ k }}
                    </v-chip>
                </template>

                <template v-slot:body.append>
                    <tr style="font-weight:bold" v-if="byCitySummray">
                        <td>Общо</td>
                        <td>{{ byMatTypeSummray.citiesCount }}</td>
                        <td>{{ byCitySummray.clientsCount }}</td>
                        <td>{{ byCitySummray.locationsCount }}</td>
                        <td>{{ byCitySummray.mats }}</td>
                        <td>{{ byCitySummray.services }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>

    </div>
</template>

<script>
import api from '../../webapi'
import * as R from 'ramda'
import * as util from '../../util'

import VDateInput from '../inputs/DateInput'
import moment from 'moment'

export default {
    data() {
        return {
            mats: [],
            reportRequested: false,
            loading: false,
            from: util.formatDateDb(moment().startOf('month')),
            to: util.formatDateDb(moment().endOf('month')),
            byCityHeaders: [
                {value: 'city', text: 'Град' },
                {value: 'clientsCount', text: 'Клиенти' },
                {value: 'locationsCount', text: 'Обекти' },
                {value: 'mats', text: 'Брой обслужени изтривалки' }
            ],
            byMatHeaders: [
                {value: 'matVariant', text: 'Вид изтривалка' },
                {value: 'cities', text: 'Градове' },
                {value: 'clientsCount', text: 'Клиенти' },
                {value: 'locationsCount', text: 'Обекти' },
                {value: 'mats', text: 'Брой обслужени изтривалки' }
            ]
        };
    },
    computed: {
        minToDate() {
            return util.formatDateDb(moment(this.from).add(1, 'days'));
        },
        maxFromDate() {
            return util.formatDateDb(moment(this.to).add(-1, 'days'));
        },
        byCityItems() {
            const matsByCity = R.groupBy(R.path(['location', 'city']), this.mats);
            const makeAccum = city => ({
                city,
                clients: {},
                locations: {},
                mats: 0,
            });

            const byCityAccum = R.mapObjIndexed(
                (mats, city) => R.reduce((acc, m) => {
                        acc.clients[m.location.client_id] = true;
                        acc.locations[m.location.id] = true;
                        acc.mats += m.count;
                        return acc;
                    }, makeAccum(city), mats),
                matsByCity);

            return R.map(this.addSetCounts, R.values(byCityAccum));
        },

        byCitySummray() {
            return this.summarize(this.byCityItems);
        },


        byMatTypeItems() {
            const matsByType = R.groupBy(R.prop('mat_type_id'), this.mats);;
            const makeAccum = matTypeId => ({
                matTypeId,
                clients: {},
                cities: {},
                locations: {},
                mats: 0,
            });

            const byTypeAccum = R.mapObjIndexed(
                (mats, matTypeId) => R.reduce((acc, m) => {
                    acc.clients[m.location.client_id] = true;
                    acc.cities[m.location.city] = true;
                    acc.locations[m.location.id] = true;
                    acc.mats += m.count;
                    return acc;
                }, makeAccum(matTypeId), mats),
                matsByType);

            return R.map(this.addSetCounts, R.values(byTypeAccum));
        },

        byMatTypeSummray() {
            return this.summarize(this.byMatTypeItems);
        },
    },
    methods: {
        async getReport() {
            this.reportRequested = true;
            this.loading = true;

            const mtLoading = api.matTypes();
            const servLoading = api.reportHistory(this.from, this.to);

            this.matTypes = Object.freeze(util.objectsById(await mtLoading));
            this.mats = Object.freeze(this.flattenMats(await servLoading));

            this.loading = false;
        },
        flattenMats(services) {
            return R.flatten(R.map(serv => R.map(R.assoc('location', serv.location), serv.mats), services));
        },
        summarize(rows) {
            function sumProps(acc, obj) {
                R.forEachObjIndexed(
                    (val, key) => {
                        if (R.type(val) == 'Object')
                            acc[key] = R.mergeLeft(acc[key], val);
                        else
                            acc[key] += val;
                    },
                    obj);
                return acc;
            }

            return this.addSetCounts(R.reduce(
                (acc, row) => R.isEmpty(acc) ? R.clone(row) : sumProps(acc, row),
                [],
                rows));
        },
        addSetCounts(group) {
            R.forEachObjIndexed((val, key) => {
                if (R.type(val) == 'Object') {
                    //console.log(val, R.keys(val), R.keys(val).length);
                    group[key + 'Count'] = R.keys(val).length;
                }
            }, group);
            return group;
        },
        rendMatType(id) {
            const mt = this.matTypes[id];
            return `${mt.code}, ${mt.type}, ${mt.size}`;
        }
    },
    components: {
        VDateInput
    }
}
</script>